import React, { useContext, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { TopMenu } from "../components/TopMenu.jsx"
import { AICreditsPanel } from "../components/ai/AICreditsPanel.jsx"
import { AITasksList } from "../components/ai/AITasksList.jsx"
import { GlobalStateContext } from "../components/providers/GlobalStateProvider.jsx"

const Ai = () => {
	const { state } = useContext(GlobalStateContext)
	const navigate = useNavigate()
	const { t } = useTranslation()

	useEffect(() => {
		if (!state.hasValidKopyPlusSubscription) {
			navigate("/upgradeplus")
		}
	}, [state.kopyPlusSubscription])

	return (
		<div>
			<TopMenu goBack="/" storeSelector />

			<div className="ai-panels">
				<div
					className="ai-tasks-panel"
					style={{
						padding: "1rem",
						background: "white",
						borderRadius: "1rem",
						boxShadow:
							"0 1px 3px 0 rgba(0,0,0,0.1), 0 1px 2px 0 rgba(0,0,0,0.06)",
						border: "1px solid #ccc",
					}}
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "0.5rem",
						}}
					>
						<div
							style={{
								width: "1.8rem",
								height: "1.8rem",
								color: "#333",
							}}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="1.8rem"
								height="1.8rem"
								viewBox="0 0 24 24"
							>
								<path
									fill="currentColor"
									d="m10 19l-2.5-5.5L2 11l5.5-2.5L10 3l2.5 5.5L18 11l-5.5 2.5L10 19Zm8 2l-1.25-2.75L14 17l2.75-1.25L18 13l1.25 2.75L22 17l-2.75 1.25L18 21Z"
								></path>
							</svg>
						</div>
						<p
							style={{
								fontSize: "2rem",
								fontWeight: "500",
								color: "#333",
							}}
						>
							{t("ai.ai_tasks")}
						</p>
					</div>

					<AITasksList />
				</div>

				<AICreditsPanel />
			</div>

			<style>{`
				.ai-panels {
					padding: 1.5rem;
					padding-top: 10rem;
					display: flex;
					flex-direction: row;
					gap: 1.5rem;
					width: 100%;
					justify-content: center;
				}
				.ai-tasks-panel {
					width: 40rem;
				}
				.ai-credits-panel {
					max-width: 25rem;
				}
				@media (max-width: 950px) {
					.ai-panels {
						margin-top: 5rem;
						flex-direction: column-reverse;
					}
					.ai-tasks-panel {
						width: 100%;
					}
					.ai-credits-panel {
						width: 100% !important;
						max-width: 100%;
					}
				}

			`}</style>
		</div>
	)
}

export default Ai
